import { Box } from "@mui/material";
import { Link } from "react-router-dom";
import PageRoutes from "../Config/PageRoutes";

const LogoMobile = () => {
  return (
    <Box
      container
      display="flex"
      flexDirection="row"
      justifyContent="center"
      alignItems="center"
      margin="0.5rem 0.5rem 0.5rem 1rem"
    >
      <Link to={PageRoutes.CHAPTER_ONE}>
        <Box>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="104.75"
            height="34"
            viewBox="0 0 104.75 34"
          >
            <g
              id="Group_3510"
              data-name="Group 3510"
              transform="translate(-10561 22792.449)"
            >
              <path
                id="Path_3781"
                data-name="Path 3781"
                d="M54.96,203.727a.162.162,0,1,0-.105-.2.163.163,0,0,0,.105.2"
                transform="translate(10526.854 -22988.094)"
                fill="#da8d15"
              />
              <path
                id="Path_3782"
                data-name="Path 3782"
                d="M53.219,201.888a.177.177,0,1,0,.115.222.177.177,0,0,0-.115-.222"
                transform="translate(10527.674 -22987.418)"
                fill="#da8d15"
              />
              <path
                id="Path_3783"
                data-name="Path 3783"
                d="M51.232,200.581a.184.184,0,1,0,.12.231.184.184,0,0,0-.12-.231"
                transform="translate(10528.554 -22986.842)"
                fill="#da8d15"
              />
              <path
                id="Path_3784"
                data-name="Path 3784"
                d="M49.114,199.5a.191.191,0,1,0,.124.24.191.191,0,0,0-.124-.24"
                transform="translate(10529.492 -22986.363)"
                fill="#da8d15"
              />
              <path
                id="Path_3785"
                data-name="Path 3785"
                d="M46.773,199.023a.2.2,0,1,0-.129-.248.2.2,0,0,0,.129.248"
                transform="translate(10530.476 -22985.988)"
                fill="#da8d15"
              />
              <path
                id="Path_3786"
                data-name="Path 3786"
                d="M44.471,198.427a.2.2,0,1,0-.133-.257.2.2,0,0,0,.133.257"
                transform="translate(10531.493 -22985.719)"
                fill="#da8d15"
              />
              <path
                id="Path_3787"
                data-name="Path 3787"
                d="M42.12,198.081a.211.211,0,1,0-.137-.265.211.211,0,0,0,.137.265"
                transform="translate(10532.532 -22985.561)"
                fill="#da8d15"
              />
              <path
                id="Path_3788"
                data-name="Path 3788"
                d="M39.743,197.993a.218.218,0,1,0-.142-.274.218.218,0,0,0,.142.274"
                transform="translate(10533.583 -22985.516)"
                fill="#da8d15"
              />
              <path
                id="Path_3789"
                data-name="Path 3789"
                d="M37.371,198.162a.225.225,0,1,0-.146-.282.225.225,0,0,0,.146.282"
                transform="translate(10534.631 -22985.584)"
                fill="#da8d15"
              />
              <path
                id="Path_3790"
                data-name="Path 3790"
                d="M35.031,198.588a.232.232,0,1,0-.151-.291.232.232,0,0,0,.151.291"
                transform="translate(10535.665 -22985.768)"
                fill="#da8d15"
              />
              <path
                id="Path_3791"
                data-name="Path 3791"
                d="M32.752,199.264a.239.239,0,1,0-.155-.3.239.239,0,0,0,.155.3"
                transform="translate(10536.673 -22986.059)"
                fill="#da8d15"
              />
              <path
                id="Path_3792"
                data-name="Path 3792"
                d="M30.559,200.18a.245.245,0,1,0-.16-.308.245.245,0,0,0,.16.308"
                transform="translate(10537.642 -22986.457)"
                fill="#da8d15"
              />
              <path
                id="Path_3793"
                data-name="Path 3793"
                d="M28.476,201.325a.252.252,0,1,0-.164-.317.253.253,0,0,0,.164.317"
                transform="translate(10538.563 -22986.957)"
                fill="#da8d15"
              />
              <path
                id="Path_3794"
                data-name="Path 3794"
                d="M26.529,202.688a.259.259,0,1,0-.168-.325.26.26,0,0,0,.168.325"
                transform="translate(10539.424 -22987.551)"
                fill="#da8d15"
              />
              <path
                id="Path_3795"
                data-name="Path 3795"
                d="M24.741,204.25a.266.266,0,1,0-.173-.334.266.266,0,0,0,.173.334"
                transform="translate(10540.215 -22988.234)"
                fill="#da8d15"
              />
              <path
                id="Path_3808"
                data-name="Path 3808"
                d="M27.184,204.636a.261.261,0,1,0-.17-.328.261.261,0,0,0,.17.328"
                transform="translate(10539.136 -22988.408)"
                fill="#da8d15"
              />
              <path
                id="Path_3809"
                data-name="Path 3809"
                d="M29.087,203.22a.254.254,0,1,0-.165-.319.254.254,0,0,0,.165.319"
                transform="translate(10538.294 -22987.791)"
                fill="#da8d15"
              />
              <path
                id="Path_3810"
                data-name="Path 3810"
                d="M31.144,202.037a.246.246,0,1,0-.16-.309.246.246,0,0,0,.16.309"
                transform="translate(10537.384 -22987.275)"
                fill="#da8d15"
              />
              <path
                id="Path_3811"
                data-name="Path 3811"
                d="M33.324,201.1a.239.239,0,1,0-.155-.3.239.239,0,0,0,.155.3"
                transform="translate(10536.421 -22986.871)"
                fill="#da8d15"
              />
              <path
                id="Path_3812"
                data-name="Path 3812"
                d="M35.6,200.432a.231.231,0,1,0-.15-.29.232.232,0,0,0,.15.29"
                transform="translate(10535.414 -22986.58)"
                fill="#da8d15"
              />
              <path
                id="Path_3813"
                data-name="Path 3813"
                d="M37.938,200.035a.224.224,0,1,0-.145-.281.224.224,0,0,0,.145.281"
                transform="translate(10534.381 -22986.412)"
                fill="#da8d15"
              />
              <path
                id="Path_3814"
                data-name="Path 3814"
                d="M40.307,199.917a.216.216,0,1,0-.141-.272.216.216,0,0,0,.141.272"
                transform="translate(10533.333 -22986.365)"
                fill="#da8d15"
              />
              <path
                id="Path_3815"
                data-name="Path 3815"
                d="M42.674,200.079a.209.209,0,1,0-.136-.262.208.208,0,0,0,.136.262"
                transform="translate(10532.287 -22986.443)"
                fill="#da8d15"
              />
              <path
                id="Path_3816"
                data-name="Path 3816"
                d="M45.006,200.522a.2.2,0,1,0-.131-.253.2.2,0,0,0,.131.253"
                transform="translate(10531.256 -22986.646)"
                fill="#da8d15"
              />
              <path
                id="Path_3817"
                data-name="Path 3817"
                d="M47.27,201.233a.194.194,0,1,0-.126-.244.194.194,0,0,0,.126.244"
                transform="translate(10530.255 -22986.967)"
                fill="#da8d15"
              />
              <path
                id="Path_3818"
                data-name="Path 3818"
                d="M49.548,201.848a.186.186,0,1,0,.121.235.186.186,0,0,0-.121-.235"
                transform="translate(10529.298 -22987.4)"
                fill="#da8d15"
              />
              <path
                id="Path_3819"
                data-name="Path 3819"
                d="M51.578,203.082a.179.179,0,1,0,.116.225.179.179,0,0,0-.116-.225"
                transform="translate(10528.398 -22987.945)"
                fill="#da8d15"
              />
              <path
                id="Path_3820"
                data-name="Path 3820"
                d="M53.353,204.875a.163.163,0,1,0-.106-.2.163.163,0,0,0,.106.2"
                transform="translate(10527.563 -22988.6)"
                fill="#da8d15"
              />
              <path
                id="Path_3827"
                data-name="Path 3827"
                d="M29.741,205.1a.255.255,0,1,0-.167-.321.256.256,0,0,0,.167.321"
                transform="translate(10538.006 -22988.619)"
                fill="#da8d15"
              />
              <path
                id="Path_3828"
                data-name="Path 3828"
                d="M31.608,203.57a.247.247,0,1,0,.31-.161.247.247,0,0,0-.31.161"
                transform="translate(10537.109 -22988.088)"
                fill="#da8d15"
              />
              <path
                id="Path_3829"
                data-name="Path 3829"
                d="M33.781,202.631a.239.239,0,1,0,.3-.155.239.239,0,0,0-.3.155"
                transform="translate(10536.15 -22987.676)"
                fill="#da8d15"
              />
              <path
                id="Path_3830"
                data-name="Path 3830"
                d="M36.059,201.98a.231.231,0,1,0,.29-.15.231.231,0,0,0-.29.15"
                transform="translate(10535.146 -22987.391)"
                fill="#da8d15"
              />
              <path
                id="Path_3831"
                data-name="Path 3831"
                d="M38.683,201.486a.222.222,0,1,0,.145.279.223.223,0,0,0-.145-.279"
                transform="translate(10534.11 -22987.24)"
                fill="#da8d15"
              />
              <path
                id="Path_3832"
                data-name="Path 3832"
                d="M40.916,201.859a.214.214,0,1,0-.139-.269.214.214,0,0,0,.139.269"
                transform="translate(10533.063 -22987.225)"
                fill="#da8d15"
              />
              <path
                id="Path_3833"
                data-name="Path 3833"
                d="M43.27,202.119a.206.206,0,1,0-.134-.259.206.206,0,0,0,.134.259"
                transform="translate(10532.023 -22987.346)"
                fill="#da8d15"
              />
              <path
                id="Path_3834"
                data-name="Path 3834"
                d="M45.57,202.681a.2.2,0,1,0-.129-.248.2.2,0,0,0,.129.248"
                transform="translate(10531.006 -22987.602)"
                fill="#da8d15"
              />
              <path
                id="Path_3835"
                data-name="Path 3835"
                d="M47.894,203.174a.189.189,0,1,0,.123.238.189.189,0,0,0-.123-.238"
                transform="translate(10530.029 -22987.984)"
                fill="#da8d15"
              />
              <path
                id="Path_3836"
                data-name="Path 3836"
                d="M49.968,204.322a.181.181,0,1,0,.118.227.181.181,0,0,0-.118-.227"
                transform="translate(10529.109 -22988.492)"
                fill="#da8d15"
              />
              <path
                id="Path_3845"
                data-name="Path 3845"
                d="M34.693,204.3a.239.239,0,1,0,.155.3.239.239,0,0,0-.155-.3"
                transform="translate(10535.88 -22988.48)"
                fill="#da8d15"
              />
              <path
                id="Path_3846"
                data-name="Path 3846"
                d="M36.669,203.819a.23.23,0,1,0,.288-.15.229.229,0,0,0-.288.15"
                transform="translate(10534.876 -22988.203)"
                fill="#da8d15"
              />
              <path
                id="Path_3847"
                data-name="Path 3847"
                d="M39.437,203.652a.221.221,0,1,0-.277.144.221.221,0,0,0,.277-.144"
                transform="translate(10533.841 -22988.072)"
                fill="#da8d15"
              />
              <path
                id="Path_3848"
                data-name="Path 3848"
                d="M41.649,203.425a.211.211,0,1,0,.137.266.212.212,0,0,0-.137-.266"
                transform="translate(10532.797 -22988.096)"
                fill="#da8d15"
              />
              <path
                id="Path_3849"
                data-name="Path 3849"
                d="M43.854,204.2a.2.2,0,1,0-.131-.254.2.2,0,0,0,.131.254"
                transform="translate(10531.765 -22988.27)"
                fill="#da8d15"
              />
              <path
                id="Path_3850"
                data-name="Path 3850"
                d="M46.224,204.545a.193.193,0,1,0,.126.243.193.193,0,0,0-.126-.243"
                transform="translate(10530.768 -22988.59)"
                fill="#da8d15"
              />
              <path
                id="Path_3779"
                data-name="Path 3779"
                d="M42.869,219.327a12.529,12.529,0,1,1-25.058,0h4.362a8.167,8.167,0,1,0,16.334,0Z"
                transform="translate(10543.189 -22995.113)"
                fill="#13407f"
              />
              <path
                id="Path_3780"
                data-name="Path 3780"
                d="M34.918,222.523a6.709,6.709,0,0,0,5.015-11.171,20.375,20.375,0,0,0-5.015,9.022,14.582,14.582,0,0,0-6.712-4.513,6.72,6.72,0,0,0,6.712,6.661"
                transform="translate(10538.604 -22991.596)"
                fill="#3a9381"
              />
              <path
                id="Path_3796"
                data-name="Path 3796"
                d="M23.131,206a.273.273,0,1,0-.177-.343.273.273,0,0,0,.177.343"
                transform="translate(10540.927 -22989)"
                fill="#da8d15"
              />
              <path
                id="Path_3797"
                data-name="Path 3797"
                d="M21.721,207.909a.279.279,0,1,0-.182-.351.28.28,0,0,0,.182.351"
                transform="translate(10541.551 -22989.836)"
                fill="#da8d15"
              />
              <path
                id="Path_3798"
                data-name="Path 3798"
                d="M20.527,209.962a.286.286,0,1,0-.186-.359.286.286,0,0,0,.186.359"
                transform="translate(10542.079 -22990.736)"
                fill="#da8d15"
              />
              <path
                id="Path_3799"
                data-name="Path 3799"
                d="M19.563,212.131a.293.293,0,1,0-.191-.367.292.292,0,0,0,.191.367"
                transform="translate(10542.507 -22991.688)"
                fill="#da8d15"
              />
              <path
                id="Path_3800"
                data-name="Path 3800"
                d="M19.218,214.179a.336.336,0,1,0-.422.219.337.337,0,0,0,.422-.219"
                transform="translate(10542.858 -22992.65)"
                fill="#da8d15"
              />
              <path
                id="Path_3801"
                data-name="Path 3801"
                d="M18.746,216.493a.353.353,0,1,0-.443.23.353.353,0,0,0,.443-.23"
                transform="translate(10543.081 -22993.66)"
                fill="#da8d15"
              />
              <path
                id="Path_3802"
                data-name="Path 3802"
                d="M20.248,216.756a.352.352,0,1,0-.229-.442.351.351,0,0,0,.229.442"
                transform="translate(10542.223 -22993.676)"
                fill="#da8d15"
              />
              <path
                id="Path_3803"
                data-name="Path 3803"
                d="M20.781,214.444a.334.334,0,1,0-.217-.42.334.334,0,0,0,.217.42"
                transform="translate(10541.982 -22992.672)"
                fill="#da8d15"
              />
              <path
                id="Path_3804"
                data-name="Path 3804"
                d="M21.419,211.838a.291.291,0,1,0,.366-.189.291.291,0,0,0-.366.189"
                transform="translate(10541.604 -22991.721)"
                fill="#da8d15"
              />
              <path
                id="Path_3805"
                data-name="Path 3805"
                d="M23.009,209.89a.284.284,0,1,0-.356.184.283.283,0,0,0,.356-.184"
                transform="translate(10541.141 -22990.789)"
                fill="#da8d15"
              />
              <path
                id="Path_3806"
                data-name="Path 3806"
                d="M23.764,207.74a.276.276,0,1,0,.347-.179.275.275,0,0,0-.347.179"
                transform="translate(10540.569 -22989.918)"
                fill="#da8d15"
              />
              <path
                id="Path_3807"
                data-name="Path 3807"
                d="M25.623,205.753a.269.269,0,1,0,.175.337.268.268,0,0,0-.175-.337"
                transform="translate(10539.897 -22989.121)"
                fill="#da8d15"
              />
              <path
                id="Path_3821"
                data-name="Path 3821"
                d="M21.976,216.311a.35.35,0,1,0,.44-.228.35.35,0,0,0-.44.228"
                transform="translate(10541.359 -22993.676)"
                fill="#da8d15"
              />
              <path
                id="Path_3822"
                data-name="Path 3822"
                d="M22.574,214.041a.332.332,0,1,0,.417-.216.332.332,0,0,0-.417.216"
                transform="translate(10541.096 -22992.68)"
                fill="#da8d15"
              />
              <path
                id="Path_3823"
                data-name="Path 3823"
                d="M23.868,211.7a.288.288,0,1,0,.188.362.289.289,0,0,0-.188-.362"
                transform="translate(10540.684 -22991.744)"
                fill="#da8d15"
              />
              <path
                id="Path_3824"
                data-name="Path 3824"
                d="M24.657,209.829a.28.28,0,1,0,.352-.182.28.28,0,0,0-.352.182"
                transform="translate(10540.176 -22990.838)"
                fill="#da8d15"
              />
              <path
                id="Path_3825"
                data-name="Path 3825"
                d="M26.409,207.76a.272.272,0,1,0,.177.341.272.272,0,0,0-.177-.341"
                transform="translate(10539.553 -22990.006)"
                fill="#da8d15"
              />
              <path
                id="Path_3826"
                data-name="Path 3826"
                d="M27.889,206.576a.264.264,0,1,0-.172-.331.264.264,0,0,0,.172.331"
                transform="translate(10538.825 -22989.262)"
                fill="#da8d15"
              />
              <path
                id="Path_3837"
                data-name="Path 3837"
                d="M51.878,205.748a.164.164,0,1,0,.107.206.164.164,0,0,0-.107-.206"
                transform="translate(10528.257 -22989.121)"
                fill="#da8d15"
              />
              <path
                id="Path_3838"
                data-name="Path 3838"
                d="M24.6,216.523a.349.349,0,1,0-.438.227.349.349,0,0,0,.438-.227"
                transform="translate(10540.494 -22993.676)"
                fill="#da8d15"
              />
              <path
                id="Path_3839"
                data-name="Path 3839"
                d="M24.6,214.066a.33.33,0,1,0,.414-.215.329.329,0,0,0-.414.215"
                transform="translate(10540.201 -22992.691)"
                fill="#da8d15"
              />
              <path
                id="Path_3840"
                data-name="Path 3840"
                d="M25.628,211.961a.285.285,0,1,0,.358-.186.285.285,0,0,0-.358.186"
                transform="translate(10539.747 -22991.777)"
                fill="#da8d15"
              />
              <path
                id="Path_3841"
                data-name="Path 3841"
                d="M27.244,209.8a.276.276,0,1,0,.179.347.276.276,0,0,0-.179-.347"
                transform="translate(10539.187 -22990.906)"
                fill="#da8d15"
              />
              <path
                id="Path_3842"
                data-name="Path 3842"
                d="M28.619,208.54a.267.267,0,1,0-.173-.335.267.267,0,0,0,.173.335"
                transform="translate(10538.504 -22990.127)"
                fill="#da8d15"
              />
              <path
                id="Path_3843"
                data-name="Path 3843"
                d="M30.561,206.505a.257.257,0,1,0,.167.323.257.257,0,0,0-.167-.323"
                transform="translate(10537.713 -22989.453)"
                fill="#da8d15"
              />
              <path
                id="Path_3844"
                data-name="Path 3844"
                d="M32.546,205.253a.248.248,0,1,0,.162.312.249.249,0,0,0-.162-.312"
                transform="translate(10536.833 -22988.9)"
                fill="#da8d15"
              />
              <path
                id="Path_3851"
                data-name="Path 3851"
                d="M48.346,205.587a.184.184,0,1,0,.12.231.184.184,0,0,0-.12-.231"
                transform="translate(10529.826 -22989.049)"
                fill="#da8d15"
              />
              <path
                id="Path_3852"
                data-name="Path 3852"
                d="M50.3,206.943a.166.166,0,1,0,.108.208.166.166,0,0,0-.108-.208"
                transform="translate(10528.955 -22989.648)"
                fill="#da8d15"
              />
              <path
                id="Path_3853"
                data-name="Path 3853"
                d="M111.534,221.156l-2.318,1.234q-.549-1.122-1.359-1.122a.933.933,0,0,0-.661.255.853.853,0,0,0-.274.654q0,.7,1.62,1.384a9.654,9.654,0,0,1,3,1.77,3.028,3.028,0,0,1,.773,2.181,3.822,3.822,0,0,1-1.3,2.942,4.649,4.649,0,0,1-7.368-1.857l2.394-1.109a5.2,5.2,0,0,0,.76,1.109,1.735,1.735,0,0,0,1.222.473q1.421,0,1.421-1.3,0-.748-1.1-1.4-.424-.212-.848-.411t-.86-.411a5.267,5.267,0,0,1-1.72-1.2,2.946,2.946,0,0,1-.636-1.957,3.464,3.464,0,0,1,1.084-2.617,3.806,3.806,0,0,1,2.693-1.035,3.674,3.674,0,0,1,3.465,2.406"
                transform="translate(10505.325 -22994.859)"
                fill="#13407f"
              />
              <rect
                id="Rectangle_11327"
                data-name="Rectangle 11327"
                width="18.396"
                height="12.264"
                transform="translate(10636.388 -22775.834)"
                fill="#13407f"
              />
              <path
                id="Path_3880"
                data-name="Path 3880"
                d="M168.253,223.073l.388-.283.388.283-.148-.458.394-.283h-.486l-.149-.464-.149.464h-.486l.394.283Z"
                transform="translate(10476.941 -22996.234)"
                fill="#fff"
              />
              <path
                id="Path_3881"
                data-name="Path 3881"
                d="M164.659,224.038l.388-.283.388.283-.148-.458.394-.283H165.2l-.149-.464-.149.465h-.486l.394.283Z"
                transform="translate(10478.526 -22996.66)"
                fill="#fff"
              />
              <path
                id="Path_3882"
                data-name="Path 3882"
                d="M162.417,225.469l-.149.465h-.486l.394.283-.148.458.388-.283.388.283-.148-.458.394-.283h-.486Z"
                transform="translate(10479.687 -22997.822)"
                fill="#fff"
              />
              <path
                id="Path_3883"
                data-name="Path 3883"
                d="M161.452,229.981l.388.283-.148-.458.394-.283H161.6l-.149-.464-.149.465h-.486l.395.283-.148.458Z"
                transform="translate(10480.112 -22999.406)"
                fill="#fff"
              />
              <path
                id="Path_3884"
                data-name="Path 3884"
                d="M162.566,233.123l-.149-.464-.149.464h-.486l.394.283-.148.458.388-.283.388.283-.148-.458.394-.283Z"
                transform="translate(10479.687 -23000.994)"
                fill="#fff"
              />
              <path
                id="Path_3885"
                data-name="Path 3885"
                d="M165.2,235.758l-.149-.463-.149.464h-.486l.394.283-.148.458.388-.283.388.283-.147-.458.394-.283Z"
                transform="translate(10478.523 -23002.156)"
                fill="#fff"
              />
              <path
                id="Path_3886"
                data-name="Path 3886"
                d="M168.79,236.713l-.149-.464-.149.464h-.486l.394.283-.148.458.388-.283.388.283-.148-.458.395-.283Z"
                transform="translate(10476.94 -23002.578)"
                fill="#fff"
              />
              <path
                id="Path_3887"
                data-name="Path 3887"
                d="M172.38,235.758l-.149-.463-.149.464H171.6l.394.283-.148.458.388-.283.388.283-.148-.458.395-.283Z"
                transform="translate(10475.357 -23002.156)"
                fill="#fff"
              />
              <path
                id="Path_3888"
                data-name="Path 3888"
                d="M175.015,233.123l-.149-.464-.149.464h-.486l.395.283-.148.458.388-.283.388.283-.148-.458.395-.283Z"
                transform="translate(10474.195 -23000.994)"
                fill="#fff"
              />
              <path
                id="Path_3889"
                data-name="Path 3889"
                d="M176.455,229.513h-.486l-.149-.464-.149.464h-.486l.394.283-.147.458.387-.283.388.283-.147-.458Z"
                transform="translate(10473.774 -22999.402)"
                fill="#fff"
              />
              <path
                id="Path_3890"
                data-name="Path 3890"
                d="M174.478,226.664l.388-.283.388.283-.148-.458.395-.282h-.486l-.149-.464-.149.464h-.486l.395.282Z"
                transform="translate(10474.195 -22997.818)"
                fill="#fff"
              />
              <path
                id="Path_3891"
                data-name="Path 3891"
                d="M172.242,222.834l-.149.465-.486,0,.393.284-.148.458.389-.284.388.284-.148-.458.395-.284h-.486Z"
                transform="translate(10475.353 -22996.66)"
                fill="#fff"
              />
              <path
                id="Path_3892"
                data-name="Path 3892"
                d="M73.619,227.877a3.7,3.7,0,0,1-6.279-1.257h9.721a6.4,6.4,0,0,0,.113-1.188,6.327,6.327,0,1,0-.49,2.445Zm-2.775-6.147a3.7,3.7,0,0,1,3.5,2.514H67.34a3.7,3.7,0,0,1,3.5-2.514"
                transform="translate(10522.59 -22995.014)"
                fill="#13407f"
              />
              <path
                id="Path_3893"
                data-name="Path 3893"
                d="M91.535,201.921a5.7,5.7,0,0,0-.6,1.3,5.188,5.188,0,0,0-.2,1.977v5.442H89.722v2.644h1.007v9.62h2.846v-9.62H96.66v-2.644H93.575v-4.75a8.506,8.506,0,0,1,.108-1.53c.006-.031.013-.06.02-.091.014-.063.03-.122.046-.177l0-.005a1.549,1.549,0,0,1,.072-.2,2.456,2.456,0,0,1,2.838-1.47v-2.607a5.094,5.094,0,0,0-5.125,2.109"
                transform="translate(10511.471 -22986.471)"
                fill="#13407f"
              />
              <path
                id="Path_3894"
                data-name="Path 3894"
                d="M132.455,219.244v1.063a6.26,6.26,0,1,0,0,10.515v.686h2.864V219.244Zm-3.348,10.028a3.708,3.708,0,0,1-3.689-3.333c-.012-.123-.019-.248-.019-.374s.007-.251.019-.374a3.708,3.708,0,1,1,3.689,4.082"
                transform="translate(10496.88 -22995.078)"
                fill="#13407f"
              />
            </g>
            <path
              id="Path_4033"
              data-name="Path 4033"
              d="M0,0V34"
              transform="translate(104.5)"
              fill="none"
              stroke="#22294d"
              stroke-width="0.5"
              opacity="0.5"
            />
          </svg>
        </Box>
      </Link>
      <Box color="#22294D" justifyContent="center" marginLeft="1rem">
        <p style={{ marginBottom: "0" }} className="logoTextMobile">
          The 2023 European Union report <br /> on{" "}
          <b> pesticide residues in food </b>
        </p>
      </Box>
    </Box>
  );
};
export default LogoMobile;
